import { ProductCard } from 'components/ProductCard.tsx/ProductCard';
import React, { FC } from 'react';
import { useAppStore } from 'stores/appStore';
import { useMockupStore } from 'stores/mockupStore';
import styles from '../SelectImageStep.scss';

export const SelectImageStepPreview: FC = () => {
  const selectedProducts = useAppStore((state) => state.selectedProducts);
  const mockups = useMockupStore((state) => state.mockups);
  const isLoading = useMockupStore((state) => state.isLoading);

  return (
    <div className={styles.selectImageStepPreview}>
      <div className={styles.selectImageStepPreviewContent}>
        {selectedProducts.map((product) => {
          const mockupUrl = mockups[product.id]?.url;

          return (
            <div key={product.id} className={styles.selectImageStepPreviewContentItem}>
              <ProductCard
                imageUrl={mockupUrl ?? product.mockupImageUrl}
                isLoading={isLoading && !mockupUrl}
                buyButtonText="ADD TO CART"
                name={product.name}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};
